module.exports = __webpack_public_path__ + "media/images/flags/1x1/irq-cf9e1460adc2ee8850f07bac3628c13e.svg";